import { render, staticRenderFns } from "./Rightbox.vue?vue&type=template&id=5529a424&scoped=true"
import script from "./Rightbox.vue?vue&type=script&lang=js"
export * from "./Rightbox.vue?vue&type=script&lang=js"
import style0 from "./Rightbox.vue?vue&type=style&index=0&id=5529a424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529a424",
  null
  
)

export default component.exports